export enum TipoUsuario {
  administrador = 'Administrador',
  comum = 'Comum'
}
